import { render } from "./ribbon.vue?vue&type=template&id=a263d6f0&scoped=true&ts=true"
import script from "./ribbon.component.ts?vue&type=script&lang=ts"
export * from "./ribbon.component.ts?vue&type=script&lang=ts"

import "./ribbon.vue?vue&type=style&index=0&id=a263d6f0&scoped=true&lang=css"

import exportComponent from "G:\\Projects\\Kml\\KmlAuth\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a263d6f0"]])

export default __exports__